export default "__VITE_ASSET__CZyh1eFz__"